
/**
 * 언어별 기본 정보 매핑
 * @nullable
 */
export type CreateCourseDraft201LocalizedBasicInfo = {[key: string]: {
  /**
   * 해당 언어의 설명
   * @nullable
   */
  description?: string | null;
  /** 해당 언어의 제목 */
  title: string;
}} | null;
